import { Typography } from '@/shared/ui/typography'

import { type FC } from 'react'

import { SideMenuLink } from './SideMenuLink'
import type { SideMenuSubItemProps } from './types'

/**
 * SideMenu.SubItem — a level-2 navigation item, child of a SideMenu.Group.
 *
 * Text-only with indentation (no icon by design). Hidden in the collapsed
 * state through the parent Group's CSS.
 */
export const SideMenuSubItem: FC<SideMenuSubItemProps> = ({ label, to, onClick, end, active }) => (
  <SideMenuLink
    to={to}
    onClick={onClick}
    end={end}
    active={active}
    baseClassName="side-menu-subitem"
    trackActive
  >
    <Typography type="paragraph" variant="md">
      {label}
    </Typography>
  </SideMenuLink>
)

SideMenuSubItem.displayName = 'SideMenuSubItem'
